module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_tvb_white-bb018cd14c662230c1c426867e2a14ed.svg";